
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import LottieVuePlayer from '@lottiefiles/vue-lottie-player'
import siteOptions from './generated/site-options.json'
import Navigation from './components/navigation.vue'

Vue.use(LottieVuePlayer)
Vue.config.productionTip = false
Vue.prototype.$siteOptions=Object.freeze(siteOptions)
Vue.component('app-navigation',Navigation)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
